import { endpoint } from "views/pages/manage/common/constant";
import { dropdownMapping } from "../../../common/utils/methods/commonMethods/utilityMethod";

export const FILTER__FORM_FIELDS_GLOBAL = {
  academicCareer: "",
  businessArea: "",
  ticketId: "",
  postCourseStartDays: "",
  modLimit: "",
  effectiveDate: "",
  startDate: "",
  endDate: "",
  branchName: "",
};

export const newRow = {
  id: "",
  academicCareer: "",
  businessArea: "",
  postCourseStartDays: "",
  modLimit: "",
  ticketId: "",
  description: "",
  status: "ACTIVE",
  applicationLevel: "NO",
  applicationList: [],
  dateControl: "",
};

export const dateControlDropdown = [
  { label: "Date of Charge Finalization", value: "FINALIZATION" },
  { label: "Date of Registration", value: "REGISTRATION" },
];

export const labelStyles = {
  fontSize: "12px",
  marginTop: "4px",
};

export const getDropdowns = async () => {
  try {
    const resp = await Promise.all([
      dropdownMapping(
        endpoint.businessArea.getAllActiveV2,
        "businessAreaDispValue",
        "id",
        "regionId",
        "businessAreaDesc",
      ),
      dropdownMapping(endpoint.region.getAllActive, "regionDispValue", "id"),
      dropdownMapping(
        endpoint.academic_career.getAllActive,
        "academicCareerDispValue",
        "id",
      ),
      dropdownMapping(endpoint.term.getAllActive, "termDispValue", "id"),
      dropdownMapping(
        endpoint.courseCategory.getAllActiveCourseCategory,
        "courseAttributeValueDispValue",
        "id",
      ),
    ]);
    // const bu =resp[0]?.map(item=>(
    //   {...item,id:item?.value}
    // ))
    return {
      allActiveBu: resp[0],
      allActiveRegions: resp[1],
      allActiveCareers: resp[2],
      allActiveTerm: resp[3],
      allCourseCategory: resp[4],
    };
  } catch (err) {
    console.error(err);
  }
};

export const applicationLevelToggleOptions = {
  onValue: { label: "Yes", value: "YES" },
  offValue: { label: "No", value: "NO" },
};
